/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.frequentBuyerPrograms.internal

import features.frequentBuyerPrograms.models.FrequentBuyerProgramsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.frequentBuyerPrograms.internal.FrequentBuyerProgramsUseCase.Params

internal class FrequentBuyerProgramsUseCase : AsyncUseCase<FrequentBuyerProgramsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val frequentBuyerProgramsService: FrequentBuyerProgramsService = FrequentBuyerProgramsServiceImpl()

    override suspend fun run(params: Params): Result<FrequentBuyerProgramsModel> {
        return frequentBuyerProgramsService.getFrequentBuyerPrograms(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
